import { render } from "./uploadModal.vue?vue&type=template&id=25cb7c1e&scoped=true"
import script from "./uploadModal.vue?vue&type=script&lang=js"
export * from "./uploadModal.vue?vue&type=script&lang=js"

import "./uploadModal.vue?vue&type=style&index=0&id=25cb7c1e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cb7c1e"]])

export default __exports__